import { render, staticRenderFns } from "./PaperSync.vue?vue&type=template&id=7020e62e&scoped=true&"
import script from "./PaperSync.vue?vue&type=script&lang=js&"
export * from "./PaperSync.vue?vue&type=script&lang=js&"
import style0 from "./PaperSync.vue?vue&type=style&index=0&id=7020e62e&scoped=true&lang=css&"
import style1 from "./PaperSync.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020e62e",
  null
  
)

export default component.exports